import { AxiosRequestConfig } from 'axios';
import vm from '@/main';
import { silentFailEndpoints } from '../helpers/rules';

/**
 * Middleware to handle silent fail endpoints.
 */
export const silentFailMiddleware = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const app = vm();

  const silentFail = silentFailEndpoints.find((sf) => (config.url?.includes(sf.path)));
  if (silentFail) {
    config.timeout = silentFail.requestTimeout;
    silentFail.onRequest(app);
  }

  return config;
};
